import type { FeatureNavNode } from "@nasam/kernel";
import type { AuthUser } from "../domain";

function firstLeaf(nodes: readonly FeatureNavNode[]): string | null {
  for (const node of nodes) {
    if (node.path !== undefined) return node.path;
    const nested = firstLeaf(node.children ?? []);
    if (nested !== null) return nested;
  }
  return null;
}

export function resolveLandingRoute(
  user: AuthUser,
  visibleNavigation: readonly FeatureNavNode[],
): string {
  if (user.userType === "staff") return "/organization/companies";
  return firstLeaf(visibleNavigation) ?? "/no-access";
}
